module.exports = __webpack_public_path__ + "img/1.6026e139.png";